// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"228075dd","453":"dc65c094","732":"897bdfa0","977":"1c6db4a8"}[chunkId] + ".chunk.js";
};